"use client";

export type StudioModeValue = "learn" | "free";

type StudioModeToggleProps = {
  value: StudioModeValue;
  onChange: (mode: StudioModeValue) => void;
};

type Option = {
  value: StudioModeValue;
  label: string;
};

const OPTIONS: Option[] = [
  { value: "learn", label: "Apprendre" },
  { value: "free", label: "Libre" },
];

export function StudioModeToggle({ value, onChange }: StudioModeToggleProps) {
  return (
    <div
      role="group"
      aria-label="Mode"
      /* `shrink-0` : c'est la pièce la plus large du groupe gauche, et sans
         elle le conteneur en `min-w-0` la comprimait sous sa taille
         min-content — les libellés repassaient à la ligne hors du `h-8`.
         En viewport court la bascule descend d'un cran pour respirer dans une
         toolbar passée à 44 px, et rendre ~24 px de large à ses voisins. */
      className="inline-flex shrink-0 items-center h-8 [@media(max-height:480px)]:h-7 rounded-lg p-0.5"
      style={{ background: "rgba(255,255,255,0.06)" }}
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.value;

        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            aria-pressed={active}
            className={`
              h-7 [@media(max-height:480px)]:h-6
              px-3 [@media(max-height:480px)]:px-2
              rounded-md text-[12px] [@media(max-height:480px)]:text-[11px]
              font-medium tracking-wide whitespace-nowrap
              transition-colors duration-150 cursor-pointer
              ${active ? "text-white" : "text-text-muted hover:text-text-secondary"}
            `}
            style={
              active
                ? {
                    background: "rgba(139, 92, 246, 0.22)",
                    boxShadow: "inset 0 0 0 1px rgba(139, 92, 246, 0.4)",
                  }
                : undefined
            }
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
